// extracted by mini-css-extract-plugin
export default {"select":"S_OJRdu_nb8_dj26Simw__select___"};